import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HsaReport from './hsaReport';
import QsaReport from './qsaReport';
import DfiReport from './dfiReport';
import SfrReport from './sfrReport';
import IuiReport from './iuiReport';
import { setAndrologyData } from '../../../../actions/andrologyAction';

const AndrologyReport = ({ activeForm, setIsReportSelected }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setAndrologyData(`${activeForm.toLowerCase()}.isReportStarted`, true),
    );
  }, []);
  console.log('activeForm', activeForm);
  return (
    <div>
      {activeForm === 'hsa' && (
        <HsaReport setIsReportSelected={setIsReportSelected} />
      )}
      {activeForm === 'qsa' && (
        <QsaReport setIsReportSelected={setIsReportSelected} />
      )}
      {activeForm === 'dfi' && (
        <DfiReport setIsReportSelected={setIsReportSelected} />
      )}
      {activeForm === 'sfr' && (
        <SfrReport setIsReportSelected={setIsReportSelected} />
      )}
      {activeForm === 'iui' && (
        <IuiReport setIsReportSelected={setIsReportSelected} />
      )}
    </div>
  );
};

export default AndrologyReport;
